<template>
  <h2
    class="shrink-0 px-4 text-2xl font-semibold capitalize-first dark:text-white"
  >
    {{ $t('navigation.settings_title') }}
  </h2>
  <nav class="min-h-0 flex-1 overflow-y-auto">
    <div class="flex flex-col divide-y divide-slate-200 dark:divide-slate-600">
      <div
        v-for="(group, index) in groups"
        :key="index"
        class="flex flex-col gap-1 py-2"
      >
        <h3
          v-if="group.title"
          class="px-3 text-base font-semibold capitalize-first dark:text-white"
        >
          {{ group.title }}
        </h3>
        <div>
          <SettingsNavLinkComponent
            v-for="link in group.links"
            :key="link.routeName"
            :route-name="link.routeName"
            :label="link.label"
            :icon="link.icon"
          />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import SettingsNavLinkComponent from './SettingsNavLinkComponent.vue'

/** Settings menu, grouped as FM's. */
export default {
  name: 'TheSettingsNav',
  components: { SettingsNavLinkComponent },
  computed: {
    groups() {
      return [
        {
          links: [
            {
              routeName: 'settings_list_general_route',
              label: this.$t('global.general'),
              icon: 'cogs'
            },
            {
              routeName: 'settings_list_events_route',
              label: this.$t('global.events'),
              icon: 'calendar-days'
            },
            {
              routeName: 'settings_list_invoicing_route',
              label: this.$t('global.invoicing'),
              icon: 'file-invoice'
            },
            {
              routeName: 'settings_notification_route',
              label: this.$t('global.notification'),
              icon: 'bell'
            }
          ]
        },
        {
          title: this.$t('navigation.settings_organisation_title'),
          links: [
            {
              routeName: 'settings_list_user_route',
              label: this.$t('navigation.content_user_title'),
              icon: 'users'
            },
            {
              routeName: 'settings_list_company_route',
              label: this.$t('navigation.content_company_title'),
              icon: 'landmark'
            },
            {
              routeName: 'settings_list_implantation',
              label: this.$t('navigation.content_implantation_title'),
              icon: 'hotel'
            },
            {
              routeName: 'settings_list_customer_route',
              label: this.$t('navigation.content_customer_title'),
              icon: 'address-book'
            }
          ]
        },
        {
          title: this.$t('navigation.settings_management_title'),
          links: [
            {
              routeName: 'settings_list_tasks_route',
              label: this.$t('global.tasks'),
              icon: 'tasks'
            },
            {
              routeName: 'settings_add_item_list_route',
              label: this.$t('navigation.list_item_title'),
              icon: 'list'
            },
            {
              routeName: 'settings_message_texts_index_route',
              label: this.$t('navigation.message_texts'),
              icon: 'envelope-open-text'
            }
          ]
        },
        {
          title: this.$t('navigation.settings_invoicing_title'),
          links: [
            {
              routeName: 'settings_list_bank_route',
              label: this.$t('navigation.content_bank_title'),
              icon: 'piggy-bank'
            },
            {
              routeName: 'settings_list_item_route',
              label: this.$t('navigation.content_item_title'),
              icon: 'ticket'
            }
          ]
        }
      ]
    }
  }
}
</script>
